import React, { useEffect, useRef, useState } from 'react';
import { Trial } from './Trial';
import { TrialModal } from '~/common/components/TrialModal';
import { gtagEnvelope } from '~/common/util/gtagEnvelope';
import { CONTENT_IDS, FORM_TYPES, MODAL_TYPES } from '~/common/consts';
import Chevy from './Modals/Chevy';
import ChevyPremiumPersonal from './Modals/ChevyPremiumPersonal';
import UnifiedChevyPremium from './Modals/UnifiedChevyPremium';
import { TrialContentProvider } from '~/common/provider/TrialContentProvider';
import { ModalContentProvider } from '~/common/provider/ModalContentProvider';
import Unified from './Modals/Unified';
import { useAppStore } from '~/common/store/appStore';
import { useShallow } from 'zustand/react/shallow';
import PasswordGen from './Modals/PasswordGen';
import BizMax from './Modals/BizMax';

const ModalShell = () => {
  const { setModifier, setFormType } = useAppStore(
    useShallow((state) => ({ setModifier: state.setModifier, setFormType: state.setFormType }))
  );
  const [activeModal, setActiveModal] = useState<string>();
  const prevModalRef = useRef<string>();

  useEffect(() => {
    window.TrialForm = {
      open: (type: string) => setActiveModal(type),
    };
    setFormType(FORM_TYPES.TRIAL);
  }, []);

  useEffect(() => {
    if (activeModal) {
      setModifier(activeModal);
      gtagEnvelope('event', `${activeModal} Trial Modal`, {
        modal_event: 'Load',
      });
    } else if (prevModalRef.current) {
      setModifier(null);
      gtagEnvelope('event', `${prevModalRef.current} Trial Modal`, {
        modal_event: 'Close',
      });
    }
    prevModalRef.current = activeModal;
  }, [activeModal]);

  if (!activeModal) {
    return null;
  }

  return (
    <TrialModal onCloseCallBack={() => setActiveModal(null)}>
      {activeModal === MODAL_TYPES.CHEVY ||
      activeModal === MODAL_TYPES.CHEVYPREMIUM ||
      activeModal === MODAL_TYPES.CHEVYPREMIUM_CONTROL ||
      activeModal === MODAL_TYPES.CHEVYPREMIUM_CONTROL1 ? (
        <ModalContentProvider contentId={CONTENT_IDS.CHEVY}>
          <Chevy />
        </ModalContentProvider>
      ) : activeModal === MODAL_TYPES.CHEVYPREMIUM_PERSONAL ? (
        <ModalContentProvider contentId={CONTENT_IDS.CHEVY}>
          <ChevyPremiumPersonal />
        </ModalContentProvider>
      ) : activeModal === MODAL_TYPES.UNIFIED_CHEVY_PREMIUM ? (
        <ModalContentProvider contentId={CONTENT_IDS.CHEVY}>
          <UnifiedChevyPremium />
        </ModalContentProvider>
      ) : activeModal === MODAL_TYPES.UNIFIED ? (
        <Unified />
      ) : activeModal === MODAL_TYPES.PASSWORDGEN ? (
        <PasswordGen />
      ) : activeModal === MODAL_TYPES.BIZMAX ? (
        <ModalContentProvider contentId={CONTENT_IDS.CHEVY}>
          <BizMax />
        </ModalContentProvider>
      ) : (
        <TrialContentProvider>
          <Trial />
        </TrialContentProvider>
      )}
    </TrialModal>
  );
};

export default ModalShell;
